/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyShipmentCarrierInvoice } from "./CompanyShipmentCarrierInvoice";
import {
  CompanyShipmentCarrierInvoiceFromJSON,
  CompanyShipmentCarrierInvoiceFromJSONTyped,
  CompanyShipmentCarrierInvoiceToJSON,
  CompanyShipmentCarrierInvoiceToJSONTyped,
} from "./CompanyShipmentCarrierInvoice";

/**
 *
 * @export
 * @interface CarrierInvoiceData
 */
export interface CarrierInvoiceData {
  /**
   *
   * @type {Array<CompanyShipmentCarrierInvoice>}
   * @memberof CarrierInvoiceData
   */
  nonVoidedCarrierInvoices: Array<CompanyShipmentCarrierInvoice>;
  /**
   *
   * @type {Array<CompanyShipmentCarrierInvoice>}
   * @memberof CarrierInvoiceData
   */
  invoicesReadyToPay: Array<CompanyShipmentCarrierInvoice>;
}

/**
 * Check if a given object implements the CarrierInvoiceData interface.
 */
export function instanceOfCarrierInvoiceData(
  value: object,
): value is CarrierInvoiceData {
  if (
    !("nonVoidedCarrierInvoices" in value) ||
    value["nonVoidedCarrierInvoices"] === undefined
  )
    return false;
  if (
    !("invoicesReadyToPay" in value) ||
    value["invoicesReadyToPay"] === undefined
  )
    return false;
  return true;
}

export function CarrierInvoiceDataFromJSON(json: any): CarrierInvoiceData {
  return CarrierInvoiceDataFromJSONTyped(json, false);
}

export function CarrierInvoiceDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceData {
  if (json == null) {
    return json;
  }
  return {
    nonVoidedCarrierInvoices: (
      json["nonVoidedCarrierInvoices"] as Array<any>
    ).map(CompanyShipmentCarrierInvoiceFromJSON),
    invoicesReadyToPay: (json["invoicesReadyToPay"] as Array<any>).map(
      CompanyShipmentCarrierInvoiceFromJSON,
    ),
  };
}

export function CarrierInvoiceDataToJSON(json: any): CarrierInvoiceData {
  return CarrierInvoiceDataToJSONTyped(json, false);
}

export function CarrierInvoiceDataToJSONTyped(
  value?: CarrierInvoiceData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    nonVoidedCarrierInvoices: (
      value["nonVoidedCarrierInvoices"] as Array<any>
    ).map(CompanyShipmentCarrierInvoiceToJSON),
    invoicesReadyToPay: (value["invoicesReadyToPay"] as Array<any>).map(
      CompanyShipmentCarrierInvoiceToJSON,
    ),
  };
}
